import { render, staticRenderFns } from "./CheckboxFormItem.vue?vue&type=template&id=be2a9f9a&"
import script from "./CheckboxFormItem.vue?vue&type=script&lang=js&"
export * from "./CheckboxFormItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxFormItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../.jenkins/workspace/DMSDashboardDeployLIVE/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports